if (!customElements.get('back-to-top')) {
  customElements.define(
    'back-to-top',
    class BackToTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.darido-back-to-top');
        this.ticking = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onScroll = this.onScroll.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.observeStickyBars = this.observeStickyBars.bind(this);
      }

      connectedCallback() {
        if (!this.button) return;
        this.button.addEventListener('click', this.scrollToTop);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('shopify:section:load', this.observeStickyBars);
        this.observeStickyBars();
        this.updateVisibility();
      }

      disconnectedCallback() {
        if (!this.button) return;
        this.button.removeEventListener('click', this.scrollToTop);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:section:load', this.observeStickyBars);
        this.stickyResizeObserver?.disconnect();
        this.stickyStateObserver?.disconnect();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.updateVisibility();
          this.ticking = false;
        });
      }

      observeStickyBars() {
        this.stickyResizeObserver?.disconnect();
        this.stickyStateObserver?.disconnect();
        this.stickyBars = [...document.querySelectorAll('.sticky-add-to-cart__bar')];
        this.stickyResizeObserver = new ResizeObserver(this.onScroll);
        this.stickyStateObserver = new MutationObserver(this.onScroll);
        for (const bar of this.stickyBars) {
          this.stickyResizeObserver.observe(bar);
          this.stickyStateObserver.observe(bar.closest('sticky-add-to-cart') || bar, {
            attributes: true,
            subtree: true,
            attributeFilter: ['data-stuck', 'data-variant-available'],
          });
        }
        this.onScroll();
      }

      updateStickyClearance() {
        const buttonBounds = this.button.getBoundingClientRect();
        let clearance = 0;
        for (const bar of this.stickyBars || []) {
          if (!bar.isConnected || bar.dataset.stuck !== 'true') continue;
          const style = getComputedStyle(bar);
          if (style.display === 'none') continue;
          const bounds = bar.getBoundingClientRect();
          if (buttonBounds.right <= bounds.left || buttonBounds.left >= bounds.right) continue;
          // Use layout height and bottom, not the animated vertical transform.
          clearance = Math.max(clearance, bar.offsetHeight + (parseFloat(style.bottom) || 0) + 12);
        }
        this.button.style.setProperty('--back-to-top-clearance', `${Math.ceil(clearance)}px`);
      }

      updateVisibility() {
        this.updateStickyClearance();
        const threshold = Math.max(480, window.innerHeight * 0.75);
        const shouldShow = window.scrollY > threshold;
        this.button.classList.toggle('is-visible', shouldShow);
        this.button.setAttribute('aria-hidden', String(!shouldShow));
        this.button.tabIndex = shouldShow ? 0 : -1;
      }

      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      }
    }
  );
}
